module.exports = __webpack_public_path__ + "img/chemistry.1939cc21.png";